export const MANACOST = [...Array(11).keys()];
